import PlayerSubHeader from './PlayerSubHeader';

export default PlayerSubHeader;
